/* eslint-disable jsx-a11y/anchor-is-valid */
import axios from "axios";
import { useFormik } from "formik";
import React, { useEffect, useState, Fragment } from "react";
import { connect, shallowEqual, useSelector, useDispatch } from "react-redux";
import * as Yup from "yup";
import * as auth from "../Auth";
import { Snackbar } from "@material-ui/core";
import AddParentForm from "./AddParentForm";
import { SnackbarWrapper } from "../Snackbar/SnackbarWrapper";
import { ParentDuplicateDialog } from "./ParentDuplicateDialog";
import { getFormattedNumber, getVanillaPhoneNumber, checkAndReplace } from "../../helpers/Formatter";
import * as familyActions from "../FamilyProfile/_redux/FamilyActions";

// UI Helpers
const initialValues = {
  firstname: "",
  lastname: "",
  mobile: "",
  homephone: "",
  address: "",
  city: "",
  state: "",
  country: "",
  zip: "",
  email: "",
  alternate_email: "",
  active_id: 1,
  //zebra123 encrypted
  password: "$2a$10$9marzvVOoF99fqhWuwOeWuDxBbE4glOm6dbGfXj6TM0rDvtISqBea",
  refferal: "Google Search",
  alt_refferal: "",
};

const getParentUrl = "/api/user/";
const parentsUrl = "/api/family-view/get/parent/";
const studentsUrl = "/api/family-view/get/student/";
const parentExistingStudentsUrl = "/api/family-view/get/parent/student/";
const duplicateCheckUrl = "/api/user/parent-duplicate-check"; //end point to get specfic student info

export const AddParent = ({
  history,
  match: {
    params: { id, isNew },
  },
}) => {
  const dispatch = useDispatch();
  // Fields

  const [parent, setParent] = useState();
  const [parents, setParents] = useState();
  const [duplicates, setDuplicates] = useState([]); //list of possible duplicate parents when adding a parent
  const [students, setStudents] = useState();
  const [existingStudents, setExistingStudents] = useState();
  const [existingValues, setExistingValues] = useState();
  const [showDuplicateDialog, setShowDuplicateDialog] = useState(false);
  const [duplicateKnown, setDuplicateKnown] = useState(false);
  // const primaryParent = useSelector();
  const [successOpen, setSuccessOpen] = useState(false);
  const [errorOpen, setErrorOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("Something went wrong");

  const handleClose = () => {
    setSuccessOpen(false);
    setErrorOpen(false);
  };
  
  // (state) => state.family.primaryParent || state.family.parents[0]
  //getbranch
  const branch = useSelector(
    (state) => state.auth.branches.currentBranch,
    shallowEqual
  );

  const family = useSelector((state) => state.family);
  const primaryParent = family.primaryParent? family.primaryParent : {} ;
  // Methods

  async function fetchParentsForCurrentBranch() {
    if (branch) {
      const result = await axios(parentsUrl + branch.branch_id);
      setParents(result.data.results);
    } else {
      setParents([]);
    }
  }

  //get the duplicate students in the db
  const duplicateCheck = async (
    values,
    setStatus,
    setSubmitting,
    studentChosen
  ) => {
    try {
      if (duplicateKnown === false) {
        const parentResult = await axios(
          duplicateCheckUrl +
            "/ " +
            values.firstname +
            "/ " +
            values.lastname +
            "/" +
            values.email
        );

        if (
          parentResult.data.results &&
          parentResult.data.results.length > 0 &&
          values.parentType != "existing"
        ) {
          setShowDuplicateDialog(true);
          setDuplicates(parentResult.data.results);
          setSubmitting(false);
        } else {
          saveParent(values, setStatus, setSubmitting, studentChosen);
        }
      } else {
        saveParent(values, setStatus, setSubmitting, studentChosen);
      }
    } catch (error) {
      console.log(error);
      setErrorOpen(true);
      setSubmitting(false);
    }
    //
  };

  async function fetchParentsExistingStudents() {
    if (parent && id) {
      const result = await axios(parentExistingStudentsUrl + parent.user_id);
      let combinedStudents = [...family.students];

      setExistingStudents(result.data.results);

      result.data.results &&
        result.data.results.map((potentialStudent) => {
          combinedStudents.filter((s) => {
            return s.user_id == potentialStudent.user_id;
          }).length <= 0
            ? combinedStudents.push(potentialStudent)
            : (potentialStudent = potentialStudent);
        });
      setStudents(combinedStudents);
    } else {
      setExistingStudents([]);
      setStudents(family.students);
    }
  }
  useEffect(() => {
    fetchParentsForCurrentBranch();
  }, [branch]);

  //if parent edit mode then get info
  useEffect(() => {
    async function getParent() {
      const res = await axios(getParentUrl + "parent/" + id);

      let values = res
        ? {
            user_id: res.data[0].parent_id,
            active_id: res.data[0].active_id,
            firstname: res.data[0].firstname,
            lastname: res.data[0].lastname,
            primary_ind: res.data[0].primary_ind,
            gender: res.data[0].gender,
            mobile: getFormattedNumber(res.data[0].mobile),
            homephone: getFormattedNumber(res.data[0].homephone),
            address: res.data[0].address,
            city: res.data[0].city,
            state: res.data[0].state,
            country: res.data[0].country,
            zip: res.data[0].zip,
            email: res.data[0].email,
            alternate_email: res.data[0].alternate_email,
            parentType: "existing",
            //zebra123 encrypted
            password:
              "$2a$10$9marzvVOoF99fqhWuwOeWuDxBbE4glOm6dbGfXj6TM0rDvtISqBea",
            refferal: res.data[0].refferal,
            alt_refferal: res.data[0].alt_refferal
              ? res.data[0].alt_refferal
              : "",
          }
        : {};
      setExistingValues(values);
      setParent(values);
    }
    id && getParent();
  }, [id]);

  useEffect(() => {
    fetchParentsExistingStudents();
  }, [id, parent]);

  const saveParent = async (
    values,
    setStatus,
    setSubmitting,
    studentChosen
  ) => {
    let finalValues = id
      ? {
          ...values,
          branch: branch.branch_id,
          students: studentChosen.map((student) => {
            return student.value;
          }),
        }
      : values.parentType == "existing"
      ? {
          ...parent,
          branch: branch.branch_id,
          students: studentChosen.map((student) => {
            return student.value;
          }),
        }
      : {
          ...values,
          branch: branch.branch_id,
          students: studentChosen.map((student) => {
            return student.value;
          }),
        };

        finalValues.mobile = getVanillaPhoneNumber(finalValues.mobile);
        finalValues.homephone = getVanillaPhoneNumber(finalValues.homephone)
        
        finalValues.firstname = checkAndReplace(finalValues.firstname);
        finalValues.lastname = checkAndReplace(finalValues.lastname);
        finalValues.zip = checkAndReplace(finalValues.zip);
        finalValues.alt_refferal = checkAndReplace(finalValues.alt_refferal);
        finalValues.address = checkAndReplace(finalValues.address);
        finalValues.city = checkAndReplace(finalValues.city);
    try {
      if (values.parentType == "new") {
        //save new parent post
        const batchesUrl = "api/user/parent";
        const result = await axios.post(batchesUrl, finalValues);
        if (result.data.res === "success") {
          setSuccessOpen(true);
          setTimeout(() => {
            history.push({
              pathname: `/family-profile/${result.data.id}/parents`,
            });
          }, 2000);
        } else {
        setErrorMessage(result.data.error || result.data.result || result.data.details || "Something went wrong");
          setErrorOpen(true);
          setSubmitting(false);
        }
      } else {
        //edit batch post
        const addParentUrl = `api/user/parent/${id ? id : finalValues.user_id}`;
        let addingStudents = studentChosen.filter((chosen) => {
          return (
            existingStudents.filter((existing) => {
              return existing.user_id == chosen.value;
            }).length == 0
          );
        });
        let add = [];
        addingStudents.map((student) => {
          add.push(student.value);
        });

        let removingStudents = existingStudents.filter((existing) => {
          return (
            studentChosen.filter((chosen) => {
              return existing.user_id == chosen.value;
            }).length <= 0
          );
        });

        let remove = [];
        removingStudents.map((student) => {
          remove.push(student.user_id);
        });

        finalValues = { ...finalValues, adding: add, removing: remove };

        const result = await axios.patch(addParentUrl, finalValues);
        if (result.status === 204 || (result.data && result.data.res === "success")) {
          const familyId = (result.data && result.data.id) || (family && (family.id || family.searchid));
          if (familyId) {
            dispatch(familyActions.fetchFamily(familyId));
            setTimeout(() => {
              history.push(`/family-profile/${familyId}/parents`);
            }, 3000);
          } else {
            setTimeout(() => {
              history.push("/dashboard");
            }, 3000);
          }
          setSuccessOpen(true);
        } else {
          setErrorMessage(result.data.error || result.data.result || result.data.details || "Something went wrong");
          setErrorOpen(true);
          setSubmitting(false);
        }
      }
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data) {
        setErrorMessage(error.response.data.error || error.response.data.result || error.response.data.details || "Something went wrong");
      } else {
        setErrorMessage("Something went wrong");
      }
      setErrorOpen(true);
      setSubmitting(false);
    }
  };

  return id && existingValues ? (
    <div>
      {console.log("id: ", id)}
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={successOpen ? successOpen : errorOpen}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <SnackbarWrapper
          onClose={handleClose}
          variant={successOpen ? "success" : "error"}
          message={
            successOpen
              ? "Parent saved successfully"
              : errorMessage
          }
        />
      </Snackbar>
      <AddParentForm id={id} initialValues={existingValues} setParent={setParent} duplicateCheck={duplicateCheck} saveParent={saveParent} parents={parents} students={students} existingStudents={existingStudents} parent={parent} isNew={isNew} primaryParent = {primaryParent} />
    </div>
  ) : (
    <div>
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={successOpen ? successOpen : errorOpen}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <SnackbarWrapper
          onClose={handleClose}
          variant={successOpen ? "success" : "error"}
          message={
            successOpen
              ? "Parent saved successfully"
              : errorMessage
          }
        />
      </Snackbar>
      <AddParentForm id={id} initialValues={initialValues} setParent={setParent} duplicateCheck={duplicateCheck} saveParent={saveParent} parents={parents} students={students} existingStudents={existingStudents} parent={parent} isNew={isNew} primaryParent={primaryParent} />
      <ParentDuplicateDialog parents={duplicates} duplicateKnown={duplicateKnown} setDuplicateKnown={setDuplicateKnown} onHide={() => {
          setShowDuplicateDialog(!showDuplicateDialog);
        }} show={showDuplicateDialog && !duplicateKnown} />
    </div>
  );
};
export default connect(null, auth.actions)(AddParent);
